import React from 'react';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import translations from './translations';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import validationSchema from './validations';
import useIntl from '@afosto/utils-react/intl/useIntl';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import FormActions from '@afosto/app-components-react/Form/FormActions';
import useForm from '@afosto/utils-react/validation/useForm';
import { subscription as subscriptionApi } from '@afosto/iam/api/Subscription';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';

const AccountNameSection = ({ debitSource, setCurrentStep, stripe }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const handleSEPAPaymentMethod = async (idealSource, name) => {
    const sourceData = {
      type: 'sepa_debit',
      sepa_debit: {
        ideal: idealSource,
      },
      currency: 'eur',
      owner: {
        name,
      },
    };

    try {
      const sourceResponse = await stripe.createSource(sourceData);
      const { source = {} } = sourceResponse;

      await subscriptionApi.addPaymentSource({ source: source.id });

      enqueueSnackbar(intl.formatMessage(translations.feedback.accountConfirmed), {
        variant: 'success',
      });
      history.push('/contract/billing');
    } catch (error) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.accountNotConfirmed), {
        variant: 'error',
      });
    }
  };
  const form = useForm({
    validationSchema,
    onSubmit: async data => {
      try {
        await handleSEPAPaymentMethod(debitSource.id, data.accountHolderName);
      } catch (err) {
        // Do something with error.
      }
    },
    onCancel: () => setCurrentStep('confirmed'),
  });

  return (
    <>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Typography variant="body1" paragraph>
          <FormattedMessage
            {...translations.description}
            values={{ last4: debitSource.ideal.iban_last4 }}
          />
        </Typography>
        <LoadingWrapper isLoading={form.isSubmitting}>
          <Form form={form} renderActions={false}>
            <TextField
              name="accountHolderName"
              label={intl.formatMessage(translations.fields.accountHolderName)}
              autoFocus
            />
            <Typography color="textSecondary" variant="body2" style={{ fontStyle: 'italic' }}>
              <FormattedMessage {...translations.mandateMessage} />
            </Typography>
            <FormActions>
              <Button type="submit" color="primary" variant="contained">
                <FormattedMessage {...translations.actions.activate} />
              </Button>
              <Button type="button" variant="outlined" onClick={() => setCurrentStep('confirmed')}>
                <FormattedMessage {...translations.actions.back} />
              </Button>
            </FormActions>
          </Form>
        </LoadingWrapper>
      </CardContent>
    </>
  );
};

AccountNameSection.propTypes = {
  debitSource: PropTypes.object,
  setCurrentStep: PropTypes.func,
  stripe: PropTypes.object,
};

AccountNameSection.defaultProps = {
  debitSource: null,
  setCurrentStep: undefined,
  stripe: undefined,
};

export default AccountNameSection;
